import { render, staticRenderFns } from "./TerminalAnswer.vue?vue&type=template&id=afd9fe60&scoped=true&"
import script from "./TerminalAnswer.vue?vue&type=script&lang=js&"
export * from "./TerminalAnswer.vue?vue&type=script&lang=js&"
import style0 from "./TerminalAnswer.vue?vue&type=style&index=0&id=afd9fe60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd9fe60",
  null
  
)

export default component.exports